<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import { faClone, faCaretLeft, faCheck, faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let editable: boolean
    export let value: FormDataContent = new FormDataContent()
    export let view = false

    let localRequired = true
    let step = 1
    let localLocked = false

    function emitChange() {
        dispatch('change')
    }

    function goEdit() {
        localRequired = item.required
        localLocked = item.locked
        step = 2
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        dispatch('edit', false)
        step = 1
    }

    function goSave() {
        item.required = localRequired
        item.locked = localLocked
        item.score = false
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    let isNew = false
    onMount(() => {})

    function setValue(v) {
        if (view) return
        value.value = v
        value = value
        emitChange()
    }

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_hair_stroke cs_element-editable-{editable} {className}" class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}
    {:else}
        <div class="acts acts_2 acts-absolute">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>
    {/if}

    {#if step === 1}
        <div class="cs_element_content">
            <div class="cs_item_title content_question">Espessura do pelo</div>
            <div class="content_answer">
                <div class="cs_hair_stroke_answer">
                    <div class="cs_hair_stroke_option" class:selected={value.value === 1} on:click={() => setValue(1)}>
                        <div class="cs_hair_stroke-1"></div>
                        <div class="cs_hair_stroke_label">Fino</div>
                    </div>
                    <div class="cs_hair_stroke_option" class:selected={value.value === 2} on:click={() => setValue(2)}>
                        <div class="cs_hair_stroke-2"></div>
                        <div class="cs_hair_stroke_label">Médio</div>
                    </div>
                    <div class="cs_hair_stroke_option" class:selected={value.value === 3} on:click={() => setValue(3)}>
                        <div class="cs_hair_stroke-3"></div>
                        <div class="cs_hair_stroke_label">Grosso</div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <label for="" class="cs_item_title edit_question">Espessura do pelo</label>
        <div class="input-inline">
            <div class="form-check form-switch cs-w-150">
                <input class="form-check-input" bind:checked={localRequired} type="checkbox" role="switch" id="localRequired" />
                <label class="form-check-label" for="localRequired">obrigatório</label>
            </div>
            <div class="form-check form-switch cs-w-150">
                <input class="form-check-input" bind:checked={localLocked} type="checkbox" role="switch" id="localLocked" />
                <label class="form-check-label" for="localLocked">Apenas leitura</label>
            </div>
        </div>
    {/if}
</div>
